import request from '@/utils/request'
const activityApi = {
  submitActivitySign521: (data) => {
    return request({
      url: '/public/activity/sign521/submit',
      method: 'post',
      data
    })
  },
  ActivityDragonLogin: (data) => {
    return request({
      url: '/auth/login',
      method: 'post',
      data
    })
  },
  // 扫码
  ActivityDragonScan: (data) => {
    return request({
      url: '/activity/scan607/scan',
      method: 'post',
      data
    })
  },
  // 获取用户地址
  getAddressList: () => {
    return request({
      url: '/client/address/list',
      method: 'get'
    })
  },
  // 获取礼品信息
  getGiftInfo: (itemCode) => {
    return request({
      url: '/item/code/' + itemCode,
      method: 'get'
    })
  },
  // 创建订单-猜谜
  createCMOrder: (data) => {
    return request({
      url: '/activity/scan607/create-cm',
      method: 'post',
      data
    })
  },
  // 创建订单-扫码
  createQROrder: (data) => {
    return request({
      url: '/activity/scan607/create-qr',
      method: 'post',
      data
    })
  },
  // 通过活动code查询活动信息
  getActivityInfo: (activityCode) => {
    return request({
      url: '/public/activity/code/' + activityCode,
      method: 'get',
      disableError: true
    })
  },
  // 判断是否已参加活动
  checkAttend: () => {
    return request({
      url: '/activity/scan607/checkAttend',
      method: 'get',
      disableError: true
    })
  },
  getQrActivityInfo: (params) => {
    return request({
      url: '/public/activity/info',
      method: 'get',
      params
    })
  },
  submitQrActivity: (data) => {
    return request({
      url: '/public/activity/qr-sign/submit',
      method: 'post',
      data
    })
  },
  registeQrActivity: (data) => {
    return request({
      url: '/public/activity/qr-sign/register',
      method: 'post',
      data
    })
  },
  getBattleList: (params) => {
    return request({
      url: '/battle/list',
      method: 'get',
      params
    })
  },
  // 提交问卷
  submitQuestionnaire: (data) => {
    return request({
      url: '/questionnaire/record/add',
      method: 'post',
      data
    })
  },
  // 判断是否参加过活动
  isJoinedQuestionnaire: (questionnaireCode) => {
    return request({
      url: '/questionnaire/query/client?questionnaireCode=' + questionnaireCode,
      method: 'get'
    })
  },

  // 感谢信-用户信息
  getClientInfo: () => {
    return request({
      url: '/lucky-bag/client-life',
      method: 'get',
      disableError: true
    })
  },
  // 感谢信-开福袋
  getBag: () => {
    return request({
      url: '/lucky-bag/open',
      method: 'get'
    })
  },

  // 获取活动时间
  getActivityTime: () => {
    return request({
      url: '/activity/red-packet-rain/check-clock',
      method: 'get'
    })
  },
  // 获取活动资格
  getEligibility: () => {
    return request({
      url: '/activity/red-packet-rain/is-partake',
      method: 'get'
    })
  },
  // 开红包，获取中奖信息
  getPrizeInfo: () => {
    return request({
      url: '/activity/red-packet-rain/click',
      method: 'get'
    })
  },
  // 查询中奖记录
  getWinningRecord: () => {
    return request({
      url: '/activity/red-packet-rain/own',
      method: 'get'
    })
  },
  // 查询集卡进度
  getCollectCardsRecord: () => {
    return request({
      url: '/activity/202004/summary',
      method: 'get'
    })
  },
  // 集卡礼包领取
  takeCollectCardsGift: (data) => {
    return request({
      url: '/activity/202004/gift/take',
      method: 'post',
      data
    })
  },

  // 表单验证
  verifyForm: (data) => {
    return request({
      url: '/public/streaming/bonus/verify',
      method: 'post',
      data
    })
  },

  // 转盘奖品列表
  getPrizeList: () => {
    return request({
      url: '/anniversary2020/query/prize',
      method: 'get'
    })
  },

  // 转盘中奖记录
  getRocordList: () => {
    return request({
      url: '/anniversary2020/query/record',
      method: 'get'
    })
  },

  // 点击抽奖
  clickDraw: () => {
    return request({
      url: '/anniversary2020//draw/submit',
      method: 'post'
    })
  },

  // 获取奖券
  takeCoupon: (data) => {
    return request({
      url: '/anniversary2020/coupon/take',
      method: 'post',
      data
    })
  },

  // 经销商注册账号
  registerAccount: (data) => {
    return request({
      url: '/public/activity/streaming/create',
      method: 'post',
      data
    })
  },
  // 直播活动领取奖券
  liveBroadcastTakeCoupon: (data) => {
    return request({
      url: '/public/activity/streaming/coupon/take',
      method: 'post',
      data
    })
  },
  // 梦想地图活动记录
  queryDreamingActivityRecord: () => {
    return request({
      url: '/activity/dreaming/query-record',
      method: 'get'
    })
  },
  // 梦想PK排行
  queryPKRanking: () => {
    return request({
      url: '/activity/dreaming/pk-ranking',
      method: 'get'
    })
  },
  // 梦想地图扫码
  dreamingScan: (data) => {
    return request({
      url: '/activity/dreaming/scan',
      method: 'post',
      data
    })
  },
  // 梦想地图 领取礼品
  dreamingTakeGift: (data) => {
    return request({
      url: '/activity/dreaming/take-gift',
      method: 'post',
      data
    })
  },
  // 梦想地图助力
  dreamingSupport: (data) => {
    return request({
      url: '/public/activity/dreaming/support',
      method: 'post',
      data
    })
  },
  // thex活动信息
  queryVideoData: (params) => {
    return request({
      url: '/public/content/query',
      method: 'get',
      params
    })
  },
  // thex活动信息
  viewIncrease: (data) => {
    return request({
      url: '/public/content/view/increase',
      method: 'post',
      data
    })
  },
  // 秒杀活动列表
  getSeckillList: (params) => {
    return request({
      url: '/activity/list',
      method: 'get',
      params
    })
  },

  // 秒杀
  seckillGifts: (params) => {
    return request({
      url: '/activity/seckill/list',
      method: 'get',
      params
    })
  },

  // 秒杀获取地址
  getAddress: () => {
    return request({
      url: '/client/address/list',
      method: 'get'
    })
  },

  // 确认秒杀
  sureSeckill: (data) => {
    return request({
      url: '/activity/seckill/submit',
      method: 'post',
      data,
      disableError: true
    })
  },

  // 视频活动投票
  voteVideo: (data) => {
    return request({
      url: '/public/thex-vote/submit',
      method: 'post',
      data
    })
  },

  // 获取投票详情
  getVoteDetails: () => {
    return request({
      url: '/public/thex-vote/total/query',
      method: 'get'
    })
  },

  // 获取用户参与情况
  getUserActivityInfo: (params) => {
    return request({
      url: '/activity/coin-draw/coin-amount/detail',
      method: 'get',
      params
    })
  },
  // 2020双十一 抽奖
  doubleEleven2020CoinDraw: (data) => {
    return request({
      url: '/activity/coin-draw/submit',
      method: 'post',
      data
    })
  },
  // 2020 感谢信
  thanksLetterDetails: () => {
    return request({
      url: '/public/thanks-letter/query-detail',
      method: 'get'
    })
  },
  // 点赞总数
  supportCount: (params) => {
    return request({
      url: '/public/thanks-letter/support-total/query',
      method: 'get',
      params
    })
  },
  // 点赞
  friendSupport: (data) => {
    return request({
      url: '/public/thanks-letter/support',
      method: 'post',
      data
    })
  },
  // 新年活动中奖客户信息
  getDrawDtail: () => {
    return request({
      url: '/activity/draw-2021/portion/win-detail',
      method: 'get'
    })
  },
  // 用户自身中奖信息
  getUserDrawInfo: () => {
    return request({
      url: '/activity/draw-2021/own/win-detail',
      method: 'get'
    })
  },
  // 抽签次数信息
  getDrawCount: () => {
    return request({
      url: '/activity/draw-2021/count/detail',
      method: 'get'
    })
  },
  // 积分兑换抽签机会
  pointGain: () => {
    return request({
      url: '/activity/draw-2021/count/point-gain',
      method: 'get'
    })
  },
  // 抽签
  startDraw: () => {
    return request({
      url: '/activity/draw-2021/submit',
      method: 'post'
    })
  },
  // 领取
  getChance: (params) => {
    return request({
      url: 'activity/draw-2021/count/receive',
      method: 'get',
      params
    })
  },

  // workshop活动
  workshopCollectTask1Submit: (data) => {
    return request({
      url: '/activity/workshop-collect/task1/submit',
      method: 'post',
      data
    })
  },
  workshopCollectTask4Submit: (data) => {
    return request({
      url: '/activity/workshop-collect/task4/submit',
      method: 'post',
      data
    })
  },
  workshopCollectTask2Submit: (data) => {
    return request({
      url: '/activity/workshop-collect/task2/submit',
      method: 'post',
      data
    })
  },
  workshopCollect: () => {
    return request({
      url: '/activity/workshop-collect/query',
      method: 'get'
    })
  },
  workshopCollectTask3Submit: (data) => {
    return request({
      url: '/activity/workshop-collect/task3/submit',
      method: 'post',
      data
    })
  },
  // 上传视频
  uploadVideo: (data) => {
    return request({
      url: '/activity/video-enroll/submit',
      method: 'post',
      data
    })
  },
  // 2021下半年扫码活动
  getAllFregment: (params) => {
    return request({
      url: '/activity/piece/collect-piece/month-piece',
      method: 'get',
      params
    })
  },
  fragmentScan: (data) => {
    return request({
      url: '/activity/piece/scan',
      method: 'post',
      disableError: true,
      data
    })
  },
  collectPieceList: (params) => {
    return request({
      url: '/activity/piece/collect-piece/list',
      method: 'get',
      params
    })
  },
  pieceClientActivityInfo: (params) => {
    return request({
      url: '/activity/piece/client-activity/info',
      method: 'get',
      params
    })
  },
  // 视频点赞
  getVideoEnrollList: (params) => {
    return request({
      url: '/activity/video-enroll/list',
      method: 'get',
      params
    })
  },
  getVideoEnrollInfo: (params) => {
    return request({
      url: '/activity/video-enroll/info',
      method: 'get',
      params
    })
  },
  videoSupport: (data) => {
    return request({
      url: '/activity/video-enroll/support',
      method: 'post',
      data
    })
  },
  posterSubmit: (data) => {
    return request({
      url: '/activity/poster/submit',
      method: 'post',
      data
    })
  },
  gbbCodeScan: (data) => {
    return request({
      url: '/gbb/scan',
      method: 'post',
      data
    })
  },
  qrCodeScan: (data) => {
    return request({
      url: '/plain/qr-code/scan',
      method: 'post',
      data
    })
  },
  qrCodeQueryCount: (data) => {
    return request({
      url: '/plain/qr-code/query-count',
      method: 'get',
      data
    })
  },
  getMidAutumnInfo: (data) => {
    return request({
      url: '/activity/coupon-2021/obtain ',
      method: 'post',
      data
    })
  },
  getMidAutumnRecordList: (data) => {
    return request({
      url: '/activity/coupon-2021/query/info',
      method: 'get',
      data
    })
  },
  // 登录
  workshopLogin: (data) => {
    return request({
      url: '/activity/workshop-enroll/submit',
      method: 'post',
      data
    })
  },
  // 2021线下活动
  boothScan: (data) => {
    return request({
      url: '/activity/booth/scan',
      method: 'post',
      data
    })
  },
  boothInquire: (params) => {
    return request({
      url: '/activity/booth/inquire',
      method: 'get',
      params
    })
  },
  boothExchange: (data) => {
    return request({
      url: '/activity/booth/exchange',
      method: 'post',
      data
    })
  },
  boothShare: (params) => {
    return request({
      url: '/activity/booth/to-share',
      method: 'get',
      params
    })
  },
  scanFirstHalf2022: data => {
    return request({
      url: '/activity/2022-scan/scan',
      method: 'post',
      data
    })
  },
  qualityAssuranceWsList: params => {
    return request({
      url: '/electronic/warranty/workshop/list',
      method: 'get',
      params
    })
  },
  qaScan: data => {
    return request({
      url: '/electronic/warranty/workshop/scan',
      method: 'post',
      data
    })
  },
  qaFeedbackScan: data => {
    return request({
      url: '/electronic/warranty/workshop/repair-scan',
      method: 'post',
      data
    })
  },
  submitCodeInfo: data => {
    return request({
      url: '/electronic/warranty/workshop/activate-warranty',
      method: 'post',
      data
    })
  },
  updateCodeInfo: data => {
    return request({
      url: '/electronic/warranty/workshop/update-warranty',
      method: 'post',
      data
    })
  },
  submitFeedback: data => {
    return request({
      url: '/electronic/warranty/workshop/report',
      method: 'post',
      data
    })
  },
  getQaFeedbackInfo: params => {
    return request({
      url: '/electronic/warranty/workshop/info',
      method: 'get',
      params
    })
  },
  qaUnbound: data => {
    return request({
      url: '/electronic/warranty/workshop/invalid',
      method: 'post',
      data
    })
  },
  qaReplaceScan: data => {
    return request({
      url: '/electronic/warranty/workshop/replace-scan',
      method: 'post',
      data
    })
  },
  qaWorkshopVerify: data => {
    return request({
      url: '/electronic/warranty/workshop/verify',
      method: 'post',
      data
    })
  },
  qaAgencyScan: data => {
    return request({
      url: '/electronic/warranty/workshop/dealer-scan',
      method: 'post',
      data
    })
  },
  qaReplaceCodeScan: data => {
    return request({
      url: '/electronic/warranty/workshop/replace',
      method: 'post',
      data
    })
  },
  queryCarByVinImg: data => {
    return request({
      url: process.env.VUE_APP_ECAT_API_SERVER + '/car/getVinCode',
      method: 'post',
      data
    })
  },
  getCarName: params => {
    return request({
      url: process.env.VUE_APP_ECAT_API_SERVER + '/car/query-vinCode',
      method: 'get',
      params
    })
  },
  getRefuelInfo: params => {
    return request({
      url: '/activity/refuel/info',
      method: 'get',
      params
    })
  },
  getLotteryDetailList: params => {
    return request({
      url: '/activity/refuel/list',
      method: 'get',
      params
    })
  },
  refuelLottery: data => {
    return request({
      url: '/activity/refuel/lottery',
      method: 'post',
      data
    })
  },
  refuelSave: data => {
    return request({
      url: '/activity/refuel/save',
      method: 'post',
      data
    })
  },
  refuelSupportStatus: data => {
    return request({
      url: '/activity/refuel/support/status',
      method: 'post',
      data
    })
  },
  refuelWxSupport: data => {
    return request({
      url: '/activity/refuel/wx-support',
      method: 'post',
      data
    })
  },
  refuelPrizeList: params => {
    return request({
      url: '/activity/refuel/prize/list',
      method: 'get',
      params
    })
  },
  get2022ScanItemList: params => {
    return request({
      url: '/activity/2022-scan/item/list',
      method: 'get',
      params
    })
  },
  get2022ScanRankingInfo: params => {
    return request({
      url: '/activity/2022-scan/ranking/info',
      method: 'get',
      params
    })
  },
  // 客户收货地址修改获取验证码
  getAddressVerifyCode: params => {
    return request({
      url: '/client/address/verify-code',
      method: 'get',
      params
    })
  },
  // 删除地址
  removeAddress: data => {
    return request({
      url: '/client/address/remove',
      method: 'post',
      data
    })
  },
  // 更新地址
  updateAddress: data => {
    return request({
      url: '/client/address/update',
      method: 'post',
      data
    })
  },
  // 新增地址
  createAddress: data => {
    return request({
      url: '/client/address/create',
      method: 'post',
      data
    })
  },
  // 获取摘星活动初始化信息
  getActivitystar: data => {
    return request({
      url: '/activity/star/activity-info',
      method: 'post',
      data
    })
  },
  // 去抽奖
  goPickstar: data => {
    return request({
      url: '/activity/star/lottery',
      method: 'post',
      data
    })
  },
  // 倒计时完成
  timeFinsh: data => {
    return request({
      url: '/activity/star/join-timing',
      method: 'post',
      data
    })
  },
  // 倒计时接口状态查询
  timeQuery: data => {
    return request({
      url: '/activity/star/check-timing',
      method: 'post',
      data
    })
  },
  // 获取折扣商品图片信息
  getUrlstar: params => {
    return request({
      url: '/activity/star/item/list',
      method: 'get',
      params
    })
  },
  // 滚动条数据
  getSroll: params => {
    return request({
      url: '/activity/star/award/list',
      method: 'get',
      params
    })
  },
  // 获取用户排名列表数据
  getRanking: params => {
    return request({
      url: '/activity/star/ranking/list',
      method: 'get',
      params
    })
  },
  // 雨刮刷视频活动详情
  getActivitywiper: params => {
    return request({
      url: '/activity/video-enroll/wiper/info',
      method: 'get',
      params
    })
  },
  // 雨刮刷视频提交
  wiperVideoEnroll: data => {
    return request({
      url: '/activity/video-enroll/wiper/submit',
      method: 'post',
      data
    })
  },
  // 雨刮刷视频活动排名
  getWiperRanking: params => {
    return request({
      url: '/activity/video-enroll/ranking/list',
      method: 'get',
      params
    })
  },
  // 获取易卡送福利初始化信息
  getActivityCoupon: data => {
    return request({
      url: '/activity/coupon/activity-info',
      method: 'post',
      data
    })
  },
  // 获取排名
  getCouponRanking: params => {
    return request({
      url: '/activity/coupon/ranking/list',
      method: 'get',
      params
    })
  },
  // 获取折扣商品信息
  getUrlCoupon: params => {
    return request({
      url: '/activity/coupon/item',
      method: 'get',
      params
    })
  },
  // 浏览15s完成接口
  timeFinshCoupon: data => {
    return request({
      url: '/activity/coupon/join-timing',
      method: 'post',
      data
    })
  },
  // 活动邀请申请成功后接口
  inviteFinsh: data => {
    return request({
      url: '/activity/coupon/invitation',
      method: 'post',
      data
    })
  },
  // 活动首页接口
  getCardActivityInfo: data => {
    return request({
      url: '/activity/card/activity-info',
      method: 'post',
      data
    })
  },
  // 抽奖排名接口
  getCardRankList: params => {
    return request({
      url: '/activity/card/ranking/list',
      method: 'get',
      params
    })
  },
  // 卡牌获取记录
  getCardCardList: params => {
    return request({
      url: '/activity/card/card/list',
      method: 'get',
      params
    })
  },
  // 抽奖记录
  getCardAwardList: params => {
    return request({
      url: '/activity/card/award/list',
      method: 'get',
      params
    })
  },
  // 活动抽奖
  LotteryCards: data => {
    return request({
      url: '/activity/card/lottery',
      method: 'post',
      data
    })
  }
}

export default activityApi
